"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyActionCreators = exports.CurrencyActionTypes = void 0;
var CurrencyActionTypes;
(function (CurrencyActionTypes) {
    CurrencyActionTypes["Load"] = "Currency.Load";
    CurrencyActionTypes["Update"] = "Currency.Update";
})(CurrencyActionTypes = exports.CurrencyActionTypes || (exports.CurrencyActionTypes = {}));
class CurrencyActionCreators {
}
exports.CurrencyActionCreators = CurrencyActionCreators;
CurrencyActionCreators.load = (currencies) => ({
    type: CurrencyActionTypes.Load,
    currencies,
});
CurrencyActionCreators.update = (currency) => ({
    type: CurrencyActionTypes.Update,
    currency,
});
//# sourceMappingURL=currency.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/currency.js
// module id = 95
// module chunks = 0